import { useState } from "react";
import { canSanitise } from "../../utils/annotationTransitions";
import styles from "./SanitisationForm.module.css";

export interface SanitisationFormProps {
  status?: string;
  sanitised?: boolean;
  reviewerIdentity: string;
  isSubmitting?: boolean;
  errorMessage?: string | null;
  onSubmit: (input: { sanitisationNotes: string }) => void;
}

export function SanitisationForm({
  status,
  sanitised,
  reviewerIdentity,
  isSubmitting = false,
  errorMessage,
  onSubmit,
}: SanitisationFormProps) {
  const [sanitisationNotes, setSanitisationNotes] = useState("");

  if (!canSanitise(status, sanitised)) {
    return null;
  }

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    onSubmit({ sanitisationNotes: sanitisationNotes.trim() });
  }

  return (
    <form
      className={styles.form}
      data-testid="sanitisation-form"
      onSubmit={handleSubmit}
    >
      <h3 className={styles.title}>Sanitisation</h3>
      <p className={styles.hint}>
        Confirm tenant-specific PII has been redacted before export.
      </p>

      <label className={styles.field}>
        <span className={styles.label}>Sanitised by</span>
        <input
          type="text"
          className={styles.input}
          value={reviewerIdentity}
          readOnly
          aria-label="Sanitised by"
        />
      </label>

      <label className={styles.field}>
        <span className={styles.label}>Sanitisation notes</span>
        <textarea
          className={styles.textarea}
          value={sanitisationNotes}
          onChange={(event) => setSanitisationNotes(event.target.value)}
          rows={3}
          disabled={isSubmitting}
          aria-label="Sanitisation notes"
        />
      </label>

      {errorMessage && (
        <p className={styles.error} data-testid="sanitisation-error">
          {errorMessage}
        </p>
      )}

      <button
        type="submit"
        className={styles.submitButton}
        disabled={isSubmitting || !reviewerIdentity}
      >
        Mark as sanitised
      </button>
    </form>
  );
}
